// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3YOF0","col":"styles_col__2nhIb"};